import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import ConfirmPopup from './ConfirmPopup';
import authService from './api-authorization/AuthorizeService';

interface AdminPriceListKwikstage {
    liftOptions: GenericList[];
    starterBayOptions: GenericList[];
    pricelistKwikstage: PriceListKwikstage[];
    pricelistKwikstageOverhire: PriceListKwikstageOverhire[];
    pricelistKwikstageMargin: PriceListKwikstageMargin[];
    pricelistKwikstageExtraHourRate: number;
    pricelistKwikstageDropBasePrice: number;
    pricelistKwikstageDropBayRate: number;
    pricelistKwikstageFGRAdditionalBayRate: number;
    showKwikstageDelete: boolean;
    kwikstageDeleteIndex: number;
    showOverhireDelete: boolean;
    overhireDeleteIndex: number;
    showMarginDelete: boolean;
    marginDeleteIndex: number;
    loading: boolean;
    errors: any;
}

interface GenericList {
    id: number;
    name: string;
}

interface PriceListKwikstage {
    id: number;
    starterBayId: number;
    liftId: number;
    labourRate: number;
    hireRate: number;
    maintenanceRate: number;
    transportRate: number;
}

interface PriceListKwikstageOverhire {
    id: number;
    starterBayId: number;
    liftId: number;
    overhireRate: number;
}

interface PriceListKwikstageMargin {
    id: number;
    priceMin: number;
    priceMax: number;
    marginPercent: number;
}

export class AdminPriceListKwikstageData extends React.Component<RouteComponentProps<{}>, AdminPriceListKwikstage> {
    constructor(props: any) {
        super(props);

        this.state = {
            liftOptions: [],
            starterBayOptions: [],
            pricelistKwikstage: [],
            pricelistKwikstageOverhire: [],
            pricelistKwikstageMargin: [],
            pricelistKwikstageExtraHourRate: 0,
            pricelistKwikstageDropBasePrice: 0,
            pricelistKwikstageDropBayRate: 0,
            pricelistKwikstageFGRAdditionalBayRate: 0,
            showKwikstageDelete: false,
            kwikstageDeleteIndex: -1,
            showMarginDelete: false,
            marginDeleteIndex: -1,
            showOverhireDelete: false,
            overhireDeleteIndex: -1,
            loading: true,
            errors: {}
        }

    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getPricelistData();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getPricelistData() {
        const token = await authService.getAccessToken();
        axios.get('api/PriceList/GetKwikstagePricelistData', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var plKwikstage = res.data.pricelistKwikstage;
            var plBlankRow = this.addBlankRow();
            plKwikstage.push(plBlankRow);

            var plKwikstageOverhire = res.data.priceListKwikstageOverhire;
            var plBlankRowOverhire = this.addBlankOverhireRow();
            plKwikstageOverhire.push(plBlankRowOverhire);

            var plKwikstageMargin = res.data.pricelistKwikstageMargin;
            var plBlankRowMargin = this.addBlankMarginRow();
            plKwikstageMargin.push(plBlankRowMargin);

            this.setState({ liftOptions: res.data.liftOptions, starterBayOptions: res.data.starterBayOptions, pricelistKwikstage: plKwikstage, pricelistKwikstageOverhire: plKwikstageOverhire, pricelistKwikstageMargin: plKwikstageMargin, pricelistKwikstageExtraHourRate: res.data.pricelistKwikstageExtraHourRate, pricelistKwikstageDropBasePrice: res.data.pricelistKwikstageDropBasePrice, pricelistKwikstageDropBayRate: res.data.pricelistKwikstageDropBayRate, pricelistKwikstageFGRAdditionalBayRate: res.data.pricelistKwikstageFGRAdditionalBayRate, loading: false })
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addBlankRow = () => {
        let pricelistItem: PriceListKwikstage = {
            id: 0,
            starterBayId: -1,
            liftId: -1,
            labourRate: 0,
            hireRate: 0,
            maintenanceRate: 0,
            transportRate: 0
        };

        return pricelistItem;
    }

    addBlankOverhireRow = () => {
        let pricelistOverhire: PriceListKwikstageOverhire = {
            id: 0,
            starterBayId: -1,
            liftId: -1,
            overhireRate: 0
        };

        return pricelistOverhire;
    }

    addBlankMarginRow = () => {
        let pricelistMargin: PriceListKwikstageMargin = {
            id: 0,
            priceMin: 0,
            priceMax: 0,
            marginPercent: 0
        }

        return pricelistMargin;
    }

    handleChange = (e: any) => {
        let item: any = {};
        //item = this.state;
        item[e.target.name] = e.target.value;
        this.setState(item);
    }

    handleCellChange = (e: any, itemIndex: number) => {
        var pricelistKwikstageList = this.state.pricelistKwikstage;
        var pricelistKwikstage = pricelistKwikstageList[itemIndex];
        let newItem: any = {};
        newItem = pricelistKwikstage;
        newItem[e.target.name] = e.target.value;

        let lastRow = pricelistKwikstageList.length - 1
        if (itemIndex === lastRow) {
            //add blank row
            var blankRow = this.addBlankRow();
            pricelistKwikstageList.push(blankRow);
        }

        this.setState({ pricelistKwikstage: pricelistKwikstageList})
    }

    handleCellChangeOverhire = (e: any, itemIndex: number) => {
        var pricelistKwikstageOverhireList = this.state.pricelistKwikstageOverhire;
        var pricelistKwikstageOverhire = pricelistKwikstageOverhireList[itemIndex];
        let newItem: any = {};
        newItem = pricelistKwikstageOverhire;
        newItem[e.target.name] = e.target.value;

        let lastRow = pricelistKwikstageOverhireList.length - 1
        if (itemIndex === lastRow) {
            //add blank row
            var blankRow = this.addBlankOverhireRow();
            pricelistKwikstageOverhireList.push(blankRow);
        }

        this.setState({ pricelistKwikstageOverhire: pricelistKwikstageOverhireList })
    }

    handleCellChangeMargin = (e: any, itemIndex: number) => {
        var pricelistKwikstageMarginList = this.state.pricelistKwikstageMargin;
        var pricelistKwikstageMargin = pricelistKwikstageMarginList[itemIndex];
        let newItem: any = {};
        newItem = pricelistKwikstageMargin;
        newItem[e.target.name] = e.target.value;

        let lastRow = pricelistKwikstageMarginList.length - 1
        if (itemIndex === lastRow) {
            //add blank row
            var blankRow = this.addBlankMarginRow();
            pricelistKwikstageMarginList.push(blankRow);
        }

        this.setState({ pricelistKwikstageMargin: pricelistKwikstageMarginList })
    }

    //Delete Kwikstage Pricelist Item
    deleteKwikstageItem = (e: any, itemIndex: number) => {
        e.preventDefault();
        this.setState({ showKwikstageDelete: true, kwikstageDeleteIndex: itemIndex });
    }

    hideKwikstageDelete = () => {
        this.setState({ showKwikstageDelete: false, kwikstageDeleteIndex: -1 });
    }

    saveKwikstageDelete = () => {
        var pricelistKwikstageList = this.state.pricelistKwikstage;
        var pricelistKwikstage = pricelistKwikstageList[this.state.kwikstageDeleteIndex];

        if (pricelistKwikstage.id === 0) {
            pricelistKwikstageList.splice(this.state.kwikstageDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ showKwikstageDelete: false, kwikstageDeleteIndex: -1 });
        } else {
            this.deleteKwikstageSave();
        }
    }

    async deleteKwikstageSave() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var pricelistKwikstageList = this.state.pricelistKwikstage;
        var pricelistKwikstage = pricelistKwikstageList[this.state.kwikstageDeleteIndex];

        var deleteItem = {
            id: pricelistKwikstage.id,
            subId: user.sub
        };

        axios.post('api/PriceList/DeletePricelistKwikstageItem', deleteItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            pricelistKwikstageList.splice(this.state.kwikstageDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ pricelistKwikstage: pricelistKwikstageList, showKwikstageDelete: false, kwikstageDeleteIndex: -1 });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //Delete Kwikstage Overhire Rate Item
    deleteKwikstageOverhire = (e: any, itemIndex: number) => {
        e.preventDefault();
        this.setState({ showOverhireDelete: true, overhireDeleteIndex: itemIndex });
    }

    hideOverhireDelete = () => {
        this.setState({ showOverhireDelete: false, overhireDeleteIndex: -1 });
    }

    saveOverhireDelete = () => {
        var pricelistOverhireList = this.state.pricelistKwikstageOverhire;
        var pricelistOverhire = pricelistOverhireList[this.state.overhireDeleteIndex];

        if (pricelistOverhire.id === 0) {
            pricelistOverhireList.splice(this.state.overhireDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ showOverhireDelete: false, overhireDeleteIndex: -1 });
        } else {
            this.deleteOverhireSave();
        }
    }

    async deleteOverhireSave() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var pricelistOverhireList = this.state.pricelistKwikstageOverhire;
        var pricelistOverhire = pricelistOverhireList[this.state.overhireDeleteIndex];

        var deleteItem = {
            id: pricelistOverhire.id,
            subId: user.sub
        };

        axios.post('api/PriceList/DeletePricelistKwikstageOverhireItem', deleteItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            pricelistOverhireList.splice(this.state.overhireDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ pricelistKwikstageOverhire: pricelistOverhireList, showOverhireDelete: false, overhireDeleteIndex: -1 });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //Delete Kwikstage Margin Item
    deleteKwikstageMargin = (e: any, itemIndex: number) => {
        e.preventDefault();
        this.setState({ showMarginDelete: true, marginDeleteIndex: itemIndex });
    }

    hideMarginDelete = () => {
        this.setState({ showMarginDelete: false, marginDeleteIndex: -1 });
    }

    saveMarginDelete = () => {
        var pricelistMarginList = this.state.pricelistKwikstageMargin;
        var pricelistMargin = pricelistMarginList[this.state.marginDeleteIndex];

        if (pricelistMargin.id === 0) {
            pricelistMarginList.splice(this.state.marginDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ showMarginDelete: false, marginDeleteIndex: -1 });
        } else {
            this.marginDeleteSave();
        }
    }

    async marginDeleteSave() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var pricelistMarginList = this.state.pricelistKwikstageMargin;
        var pricelistMargin = pricelistMarginList[this.state.marginDeleteIndex];

        var deleteItem = {
            id: pricelistMargin.id,
            subId: user.sub
        };

        axios.post('api/PriceList/DeletePricelistKwikstageMarginItem', deleteItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            pricelistMarginList.splice(this.state.marginDeleteIndex, 1);
            toast.success("Item removed successfully");
            this.setState({ pricelistKwikstageMargin: pricelistMarginList, showMarginDelete: false, marginDeleteIndex: -1 });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        //1. Check Kwikstage Pricelist
        let items = this.state.pricelistKwikstage;
        if (items.length === 1) {
            errors["pricelistitems"] = "Please enter at least one item!";
            this.setState({ errors: errors });
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (items[i].liftId < 1) {
                newErrorString += "Lift Type, ";
                error = true;
            }

            if (!items[i].labourRate || items[i].labourRate <= 0) {
                newErrorString += "Labour Rate, ";
                error = true;
            }

            if (!items[i].hireRate || items[i].hireRate <= 0) {
                newErrorString += "Hire Rate, ";
                error = true;
            }

            if (!items[i].maintenanceRate || items[i].maintenanceRate <= 0) {
                newErrorString += "Maintenance Rate, ";
                error = true;
            }

            if (!items[i].transportRate || items[i].transportRate <= 0) {
                newErrorString += "Transport Rate, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errors["pricelistitems"] = errorString;
        }

        //2. Check Kwikstage Overhire List
        let overhireItems = this.state.pricelistKwikstageOverhire;
        var rowNumberOverhire = 0;
        var errorStringOverhire = "Please enter the following values: ";
        var errorOverhire = false;

        for (var i = 0; i < overhireItems.length - 1; i++) {
            rowNumberOverhire += 1;
            var newErrorStringOverhire = "";

            if (overhireItems[i].starterBayId < 1) {
                newErrorStringOverhire += "Bay Type, ";
                errorOverhire = true;
            }

            if (overhireItems[i].liftId < 1) {
                newErrorStringOverhire += "Lift Type, ";
                errorOverhire = true;
            }

            if (!overhireItems[i].overhireRate || overhireItems[i].overhireRate <= 0) {
                newErrorStringOverhire += "Overhire Rate, ";
                errorOverhire = true;
            }

            if (newErrorStringOverhire != "") {
                errorStringOverhire += "\n"
                errorStringOverhire += "Row " + rowNumberOverhire + ": " + newErrorStringOverhire;
                errorStringOverhire = errorStringOverhire.substring(0, errorStringOverhire.length - 2);
            }
        }
        if (errorOverhire) {
            formIsValid = false;
            errors["pricelistoverhireitems"] = errorString;
        }


        //3. Check Kwikstage Margin List
        let marginItems = this.state.pricelistKwikstageMargin;
        var rowNumberMargin = 0;
        var errorStringMargin = "Please enter the following values: ";
        var errorMargin = false;

        for (var i = 0; i < marginItems.length - 1; i++) {
            rowNumberMargin += 1;
            var newErrorStringMargin = "";

            if (!marginItems[i].priceMin || marginItems[i].priceMin <= 0) {
                newErrorStringMargin += "Price Min, ";
                errorMargin = true;
            }

            if (!marginItems[i].priceMax || marginItems[i].priceMax <= 0) {
                newErrorStringMargin += "Price Max, ";
                errorMargin = true;
            }

            if (!marginItems[i].marginPercent || marginItems[i].marginPercent <= 0) {
                newErrorStringMargin += "Margin Percent, ";
                errorMargin = true;
            }
            
            if (newErrorStringMargin != "") {
                errorStringMargin += "\n"
                errorStringMargin += "Row " + rowNumberMargin + ": " + newErrorStringMargin;
                errorStringMargin = errorStringMargin.substring(0, errorStringMargin.length - 2);
            }

        }
        if (errorMargin) {
            formIsValid = false;
            errors["pricelistmarginitems"] = errorString;
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    submit = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.saveKwistagePricelist();
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    async saveKwistagePricelist() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let plKwikstage = this.state.pricelistKwikstage;
        plKwikstage.pop();
        let plKwikstageOverhire = this.state.pricelistKwikstageOverhire;
        plKwikstageOverhire.pop();
        let plKwikstageMargin = this.state.pricelistKwikstageMargin;
        plKwikstageMargin.pop();

        var extraHours = this.state.pricelistKwikstageExtraHourRate * 1;
        var dropBasePrice = this.state.pricelistKwikstageDropBasePrice * 1;
        var dropBayRate = this.state.pricelistKwikstageDropBayRate * 1;
        var addBayRate = this.state.pricelistKwikstageFGRAdditionalBayRate * 1;

        var savePriceList = {
            pricelistKwikstageExtraHourRate: extraHours,
            pricelistKwikstageDropBasePrice: dropBasePrice,
            pricelistKwikstageDropBayRate: dropBayRate,
            pricelistKwikstageFGRAdditionalBayRate: addBayRate,
            priceListKwikstage: plKwikstage,
            priceListKwikstageOverhire: plKwikstageOverhire,
            priceListKwikstageMargin: plKwikstageMargin,
            subId: user.sub
        };

        axios.post('api/PriceList/SaveKwikstagePricelist', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                this.setState({ loading: true });
                this.getPricelistData();
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Price Lists</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let pricelistKwikstage = this.state.pricelistKwikstage;
        let pricelistKwikstageOverhire = this.state.pricelistKwikstageOverhire;
        let pricelistKwikstageMargin = this.state.pricelistKwikstageMargin;
        let liftOptions = this.state.liftOptions;
        let starterBayOptions = this.state.starterBayOptions;
        let lastRow = pricelistKwikstage.length - 1;
        let lastRowOverhire = pricelistKwikstageOverhire.length - 1;
        let lastRowMargin = pricelistKwikstageMargin.length - 1;

        let confirmKwikstagePopup = <ConfirmPopup heading="Delete Kwikstage Pricelist Item?" text="Are you sure you want to delete this item?" hideConfirmModal={this.hideKwikstageDelete} showConfirmModal={this.state.showKwikstageDelete} saveConfirmModal={this.saveKwikstageDelete} />
        let confirmOverhirePopup = <ConfirmPopup heading="Delete Kwikstage Overhire Item?" text="Are you sure you want to delete this item?" hideConfirmModal={this.hideOverhireDelete} showConfirmModal={this.state.showOverhireDelete} saveConfirmModal={this.saveOverhireDelete} />
        let confirmMarginPopup = <ConfirmPopup heading="Delete Kwikstage Margin Item?" text="Are you sure you want to delete this item?" hideConfirmModal={this.hideMarginDelete} showConfirmModal={this.state.showMarginDelete} saveConfirmModal={this.saveMarginDelete} />

        return (
            <form onSubmit={this.submit}>
                <div className="static-modal">
                    {confirmKwikstagePopup}
                    {confirmOverhirePopup}
                    {confirmMarginPopup}
                </div>
                
                <div className="input-group-parent">
                    <span>1. Enter the rates for each Kwikstage Lift</span>
                    <div className="table__margin overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th></th>
                                    <th>Bay Type</th>
                                    <th>Lift Type</th>
                                    <th>Labour Rate</th>
                                    <th>Hire Rate</th>
                                    <th>Maint. Rate</th>
                                    <th>Transport Rate</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {pricelistKwikstage.map((item, index) =>
                                    <tr key={index}>
                                        <td className="hidden">{item.id}</td>
                                        <td className="table__text--align">{index + 1}</td>
                                        <td className="table__text--align">
                                            <select className="select table__select--size" id="starterBayId" name="starterBayId" value={item.starterBayId} onChange={(e) => this.handleCellChange(e, index)}>
                                                <option hidden defaultValue="-1"></option>
                                                {starterBayOptions.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className="table__text--align">
                                            <select className="select table__select--size" id="liftId" name="liftId" value={item.liftId} onChange={(e) => this.handleCellChange(e, index)}>
                                                <option hidden defaultValue="-1"></option>
                                                {liftOptions.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright' id="labourRate" name="labourRate" value={item.labourRate} onChange={(e) => this.handleCellChange(e, index)} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright' id="hireRate" name="hireRate" value={item.hireRate} onChange={(e) => this.handleCellChange(e, index)} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright' id="maintenanceRate" name="maintenanceRate" value={item.maintenanceRate} onChange={(e) => this.handleCellChange(e, index)} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright' id="transportRate" name="transportRate" value={item.transportRate} onChange={(e) => this.handleCellChange(e, index)} /></td>
                                        <td className="table__text--align">
                                            {index != lastRow ?
                                                <div className="delete--tablecell">
                                                    <a className="makeitred" href="#" onClick={(e) => this.deleteKwikstageItem(e, index)}>
                                                        <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                                    </a>
                                                </div> : ""
                                            }
                                        </td>
                                    </tr>

                                )}
                            </tbody>
                        </table>
                        {this.state.errors["pricelistitems"] ?
                            (this.state.errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                                return <span className="label errors" key={key}>{item}<br /></span>
                            })
                            : ""}
                    </div>
                </div>

                <div className="input-group-parent">
                    <span className="pricelist-margin-place">2. Enter the Margin % for each Price Range</span>
                    <div className="table__margin pricelist-margin-place overflowAuto">
                        <table className="table tableColours pricelist-margin-width">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th></th>
                                    <th className="table__text--align">Price Min</th>
                                    <th className="table__text--align">Price Max</th>
                                    <th className="table__text--align">Margin %</th>
                                    <th className="table__text--align"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {pricelistKwikstageMargin.map((item, index) =>
                                    <tr key={index}>
                                        <td className="hidden">{item.id}</td>
                                        <td className="table__text--align">{index + 1}</td>
                                        <td className="table__text--align"><input type='number' min="0" step="1" className='form-control textalignright' id="priceMin" name="priceMin" value={item.priceMin} onChange={(e) => this.handleCellChangeMargin(e, index)} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="1" className='form-control textalignright' id="priceMax" name="priceMax" value={item.priceMax} onChange={(e) => this.handleCellChangeMargin(e, index)} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="1" className='form-control textalignright' id="marginPercent" name="marginPercent" value={item.marginPercent} onChange={(e) => this.handleCellChangeMargin(e, index)} /></td>
                                        <td className="table__text--align">
                                            {index != lastRowMargin ?
                                                <div className="delete--tablecell">
                                                    <a className="makeitred" href="#" onClick={(e) => this.deleteKwikstageMargin(e, index)}>
                                                        <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                                    </a>
                                                </div> : ""
                                            }
                                        </td>
                                    </tr>

                                )}
                            </tbody>
                        </table>
                        {this.state.errors["pricelistmarginitems"] ?
                            (this.state.errors["pricelistmarginitems"]).split("\n").map((item: any, key: any) => {
                                return <span className="label errors" key={key}>{item}<br /></span>
                            })
                            : ""}
                    </div>
                </div>

                <div className="input-group-parent">
                    <span>3. Enter the Overhire rates</span>
                    <div className="table__margin overflowAuto">
                        <table className="table tableColours pricelist-margin-width">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th></th>
                                    <th className="table__text--align">Bay Type</th>
                                    <th className="table__text--align">Lift Type</th>
                                    <th className="table__text--align">Overhire Rate</th>
                                    <th className="table__text--align"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {pricelistKwikstageOverhire.map((item, index) =>
                                    <tr key={index}>
                                        <td className="hidden">{item.id}</td>
                                        <td className="table__text--align">{index + 1}</td>
                                        <td className="table__text--align">
                                            <select className="select table__select--size" id="starterBayId" name="starterBayId" value={item.starterBayId} onChange={(e) => this.handleCellChangeOverhire(e, index)}>
                                                <option hidden defaultValue="-1"></option>
                                                {starterBayOptions.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className="table__text--align">
                                            <select className="select table__select--size" id="liftId" name="liftId" value={item.liftId} onChange={(e) => this.handleCellChangeOverhire(e, index)}>
                                                <option hidden defaultValue="-1"></option>
                                                {liftOptions.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.001" className='form-control textalignright' id="overhireRate" name="overhireRate" value={item.overhireRate} onChange={(e) => this.handleCellChangeOverhire(e, index)} /></td>
                                        <td className="table__text--align">
                                            {index != lastRowOverhire ?
                                                <div className="delete--tablecell">
                                                    <a className="makeitred" href="#" onClick={(e) => this.deleteKwikstageOverhire(e, index)}>
                                                        <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                                    </a>
                                                </div> : ""
                                            }
                                        </td>
                                    </tr>

                                )}
                            </tbody>
                        </table>
                        {this.state.errors["pricelistoverhireitems"] ?
                            (this.state.errors["pricelistoverhireitems"]).split("\n").map((item: any, key: any) => {
                                return <span className="label errors" key={key}>{item}<br /></span>
                            })
                            : ""}
                    </div>
                </div>

                <div className="input-group-parent">
                    <span className="pricelist-margin-place">4. Enter the extra hour (difficult job) rate</span>
                    <label className="input-group pricelist-margin-place" htmlFor="pricelistKwikstageExtraHourRate">
                        <span className="label">Extra Hour Rate</span>
                        <input type='number' min="0" step="1" id="pricelistKwikstageExtraHourRate" name="pricelistKwikstageExtraHourRate" className='form-control input--small textalignright' value={this.state.pricelistKwikstageExtraHourRate} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <span className="pricelist-margin-place">5. Enter the drop base price</span>
                    <label className="input-group pricelist-margin-place" htmlFor="pricelistKwikstageDropBasePrice">
                        <span className="label">Drop Base Price</span>
                        <input type='number' min="0" step="1" id="pricelistKwikstageDropBasePrice" name="pricelistKwikstageDropBasePrice" className='form-control input--small textalignright' value={this.state.pricelistKwikstageDropBasePrice} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <span className="pricelist-margin-place">6. Enter the drop bay rate</span>
                    <label className="input-group pricelist-margin-place" htmlFor="pricelistKwikstageDropBayRate">
                        <span className="label">Drop Bay Rate</span>
                        <input type='number' min="0" step="1" id="pricelistKwikstageDropBayRate" name="pricelistKwikstageDropBayRate" className='form-control input--small textalignright' value={this.state.pricelistKwikstageDropBayRate} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <span className="pricelist-margin-place">7. Enter the additional bay rate for FGR</span>
                    <label className="input-group pricelist-margin-place" htmlFor="pricelistKwikstageFGRAdditionalBayRate">
                        <span className="label">FGR Bay Rate</span>
                        <input type='number' min="0" step="1" id="pricelistKwikstageFGRAdditionalBayRate" name="pricelistKwikstageFGRAdditionalBayRate" className='form-control input--small textalignright' value={this.state.pricelistKwikstageFGRAdditionalBayRate} onChange={(e) => this.handleChange(e)} />
                    </label>
                </div>

                <div className="colAlignRight marginBottom10">
                    <button className="defaultbutton defaultbutton__large" type="submit">Save</button>
                </div>
            </form>
        );

    }

};